(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('ResourceDialogController', ResourceDialogController);

    ResourceDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Resource', 'Round', 'ResourceKey'];

    function ResourceDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Resource, Round, ResourceKey) {
        var vm = this;

        vm.resource = entity;
        vm.clear = clear;
        vm.save = save;
        vm.rounds = Round.query();
        vm.resourcekeys = ResourceKey.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.resource.id !== null) {
                Resource.update(vm.resource, onSaveSuccess, onSaveError);
            } else {
                Resource.save(vm.resource, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('portalApp:resourceUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
